<div class="wrapper relative">
  <div class="w-full mb-14 text-center">
    <span class="header text-center font-normal text-base md:text-lg">
      {{ 'profile.details' | translate }}
    </span>
  </div>
  @if (isReloading()) {
    <korviu-loader></korviu-loader>
  }
  @if (isLoading()) {
    <div class="relative min-h-10">
      <korviu-loader></korviu-loader>
    </div>
  } @else {
    <div class="details-body flex flex-col gap-4 md:gap-6">
      <app-bank-info
        [isAdding]="false"
        [(bankInfo)]="bankInfo"
        [collapsable]="true"
        [hideButtons]="true"
        [(bankInfoIsValid)]="bankInfoIsValid"
      ></app-bank-info>
      <app-documentation
        [idEdit]="idEdit"
        [taxEdit]="taxEdit"
        [isAdding]="false"
        [documentation]="documentation()"
        [isUsAccount]="bankInfo?.account_type === 'US'"
        [collapsable]="true"
      ></app-documentation>
      @if (showDetailsButtons) {
        <div class="flex flex-row gap-4">
          <korviu-button class="flex-1" color="ghost" (onclick)="onBack()">
            {{ 'common.back' | translate }}
          </korviu-button>
          <korviu-button class="flex-1" color="tertiary" (onclick)="onSubmit()" [disabled]="!submitButtonEnabled">
            {{ 'common.submit' | translate }}
          </korviu-button>
        </div>
      }
    </div>
  }
</div>
